import { render } from "./sendOrderList.vue?vue&type=template&id=892c6274&scoped=true"
import script from "./sendOrderList.vue?vue&type=script&lang=js"
export * from "./sendOrderList.vue?vue&type=script&lang=js"

import "./sendOrderList.vue?vue&type=style&index=0&id=892c6274&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892c6274"]])

export default __exports__